import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import ProductEcosystem from './components/ProductEcosystem';
import Testimonials from './components/Testimonials';
import UseCases from './components/UseCases';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <Hero />
      <HowItWorks />
      <Features />
      <ProductEcosystem />
      <Testimonials />
      <UseCases />
      <FAQ />
      <Footer />
    </div>
  );
}
